// extracted by mini-css-extract-plugin
export var SearchResults = "SearchResults-module--SearchResults--DIDdH";
export var AutocompleteHeading = "SearchResults-module--AutocompleteHeading--3UBFu";
export var ListItem = "SearchResults-module--ListItem--33vwF";
export var Suggestion = "SearchResults-module--Suggestion--1ql7S";
export var InfiniteListAnchor = "SearchResults-module--InfiniteListAnchor--1SW0Q";
export var ViewMoreButton = "SearchResults-module--ViewMoreButton--3zZPv";
export var EndOfResults = "SearchResults-module--EndOfResults--14gdG";